import type { FC } from 'react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { StyledButton, StyledIcon } from './styled';

import { IconName } from '../Icon';

export const GoBack: FC = () => {
    const navigate = useNavigate();

    const onClickHandler = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    return (
        <StyledButton onClick={onClickHandler}>
            <StyledIcon iconName={IconName.ARROW} />
            Back
        </StyledButton>
    );
};
